export default __webpack_public_path__ + "static/media/OurStoryBanner.01043123.png";